import React,
{
useEffect,
useState
}
from "react";

import "./templates.css";
import {
getMessageTemplates,
getDesignTemplates
}
from "../../../services/TemplateService";


function Templates() {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [designs, setDesigns] = useState([]);
  const [selectedDesign, setSelectedDesign] = useState(null);

  const [loading, setLoading] = useState(true);
  const [designLoading, setDesignLoading] = useState(false);

  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = async () => {
    try {
      const data = await getMessageTemplates();
      setTemplates(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleTemplateSelect = async (template) => {
    setSelectedTemplate(template);
    setSelectedDesign(null);

    try {
      setDesignLoading(true);

      const data = await getDesignTemplates(template.id);

      setDesigns(data);

      if (data.length > 0) {
        setSelectedDesign(data[0]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setDesignLoading(false);
    }
  };

  return (
    <div className="templates-page">

      {/* LEFT PANEL */}

      <div className="templates-sidebar">

        <div className="templates-sidebar-header">
          <h1>Templates</h1>
          <p>Communication template library</p>
        </div>

        {
          loading ? (
            <div className="template-loading">
              Loading templates...
            </div>
          ) : (
            <div className="template-list-templates">

              {
                templates.map((template) => (

                  <div
                    key={template.id}
                    className={`template-card ${
                      selectedTemplate?.id === template.id
                        ? "active-template"
                        : ""
                    }`}
                    onClick={() => handleTemplateSelect(template)}
                  >

                    <div className="template-card-top">

                      <div className="template-icon">
                        {
                          template.channel_type === "EMAIL"
                            ? "✉"
                            : template.channel_type === "SMS"
                            ? "📱"
                            : "🟢"
                        }
                      </div>

                      <span
                        className={`channel-badge ${template.channel_type.toLowerCase()}`}
                      >
                        {template.channel_type}
                      </span>

                    </div>

                    <h3>{template.name}</h3>

                    <p className="template-type">
                      {template.message_type}
                    </p>

                    <div className="variables-wrapper">
                      {
                        template.required_vars.map((variable, index) => (
                          <span key={index} className="variable-chip">
                            {variable}
                          </span>
                        ))
                      }
                    </div>

                  </div>

                ))
              }

            </div>
          )
        }

      </div>

      {/* RIGHT PANEL */}

      <div className="template-preview-section">

        {
          !selectedTemplate ? (

            <div className="empty-template-state">

              <div className="empty-animation"></div>

              <h2>Select a Template</h2>

              <p>
                Choose a communication template to preview
                designs and configurations.
              </p>

              <div className="empty-badges">
                <span>EMAIL</span>
                <span>SMS</span>
                <span>WHATSAPP</span>
              </div>

            </div>

          ) : (

            <>

              <div className="preview-header">

                <div>
                  <h2>{selectedTemplate.name}</h2>
                  <p>{selectedTemplate.slug}</p>
                </div>

                <span
                  className={`channel-badge large ${selectedTemplate.channel_type.toLowerCase()}`}
                >
                  {selectedTemplate.channel_type}
                </span>

              </div>

              {/* DESIGN LIST */}

              <div className="design-grid">

                {
                  designLoading ? (
                    <div className="template-loading">
                      Loading designs...
                    </div>
                  ) : (

                    designs.map((design) => (

                      <div
                        key={design.id}
                        className={`design-card ${
                          selectedDesign?.id === design.id
                            ? "active-design"
                            : ""
                        }`}
                        onClick={() => setSelectedDesign(design)}
                      >

                        <div className="design-preview-template">

                          {
                            design.preview_img ? (

                              <img
                                src={design.preview_img}
                                alt={design.name}
                              />

                            ) : (

                              <div
                                className="html-preview"
                                dangerouslySetInnerHTML={{
                                  __html: design.body_content,
                                }}
                              />

                            )
                          }

                        </div>

                        <div className="design-info">

                          <h4>{design.name}</h4>

                          <span>
                            {design.orientation === "V"
                              ? "Vertical"
                              : "Horizontal"}
                          </span>

                        </div>

                      </div>

                    ))

                  )
                }

              </div>

              {/* LIVE PREVIEW */}

              {
                selectedDesign && (

                  <div className="live-preview-wrapper">

                    <div className="preview-topbar">
                      <div className="preview-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>

                      <p>Email Preview</p>
                    </div>

                    <div className="live-preview-body">

                      <div
                        className="live-email-preview"
                        dangerouslySetInnerHTML={{
                          __html: selectedDesign.body_content,
                        }}
                      />

                    </div>

                  </div>

                )
              }

            </>

          )
        }

      </div>

    </div>
  );
}

export default Templates;